// status: "active" or "legacy"

// app__channelFields.js

const channels = [
  // GDN Network
  {
    name: "adwordsCampaignId",
    status: "active",
    channel: "google-display",
    targetingFieldName: "targetingGoogleDisplay"
  },
  {
    name: "youTubeCampaignId",
    status: "active",
    channel: "youtube",
    targetingFieldName: "targetingYouTube"
  },
  {
    name: "ebayKleinanzeigenId",
    status: "active",
    channel: "ebay-kleinanzeigen",
    targetingFieldName: "targetingEbayKleinanzeigen"
  },
  // This is a special case
  {
    name: "googleSearchCampaignId",
    status: "active",
    channel: "google-search",
    targetingFieldName: "targetingGoogleSearch"
  },
  // Facebook & Instagram
  {
    name: "facebookCampaignId",
    status: "active",
    channel: "facebook",
    targetingFieldName: "targetingFacebook"
  },
  //{name: "facebookCampaignId2", status: "active", channel: "facebook, targetingFieldName: """},
  {
    name: "facebookCampaignId",
    status: "active",
    channel: "instagram",
    targetingFieldName: "targetingFacebook"
  },
  // Twitter
  {
    name: "twitterCampaignId",
    status: "active",
    channel: "twitter",
    targetingFieldName: "targetingTwitter"
  },
  // Indeed

  // For these channels we do set the ID manually
  {
    name: "snapchatCampaignId",
    status: "active",
    channel: "snapchat",
    targetingFieldName: "targetingSnapchat"
  },
  { name: "indeedCampaignId", status: "active", channel: "indeed", targetingFieldName: "" },
  {
    name: "redditCampaignId",
    status: "active",
    channel: "reddit",
    targetingFieldName: "targetingReddit"
  },
  { name: "pinterestCampaignId", status: "active", channel: "pinterest", targetingFieldName: "" },
  { name: "spotifyCampaignId", status: "active", channel: "spotify", targetingFieldName: "" },

  // for this channel we dont set an id!
  { name: "linkedInCampaignId", status: "active", channel: "linkedin", targetingFieldName: "" },
  {
    name: "linkedInFeedCampaignId",
    status: "active",
    channel: "linkedin-feed",
    targetingFieldName: ""
  },

  { name: "tikTokCampaignId", status: "active", channel: "tiktok", targetingFieldName: "" }
  // Legacy
  // {name: "linkedInCampaignIds", status: "legacy", channel: "linkedin"}
];

module.exports = channels;

module.exports.channelsFieldsByShortName = channels.reduce(
  (acc, channelField) => ({ ...acc, [channelField.channel]: channelField }),
  {}
);
